(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ala-harvest-offer"] && !Shopify.designMode) return;
  try {
    
(()=>{function mount(root){if(root.dataset.ready)return;root.dataset.ready='1';const end=Date.parse(root.dataset.end),details=root.querySelector('details'),summary=root.querySelector('summary'),close=root.querySelector('.aho-close'),key='ala-offer-'+root.dataset.key;let dismissed=false;try{dismissed=sessionStorage.getItem(key)==='1'}catch{}function remember(){try{sessionStorage.setItem(key,'1')}catch{}}function hide(){details.open=false;remember();summary.focus()}close.addEventListener('click',hide);root.addEventListener('keydown',event=>{if(event.key==='Escape'&&details.open){event.preventDefault();hide()}});details.addEventListener('toggle',()=>{if(!details.open)remember()});root.querySelector('.aho-cta').addEventListener('click',remember);function reveal(){if(Date.now()>=end)return;root.hidden=false;if(!dismissed)details.open=true}setTimeout(reveal,5000);setInterval(()=>{if(Date.now()>=end)root.hidden=true},60000)}document.querySelectorAll('.aho').forEach(mount);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.aho').forEach(mount))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ala-harvest-opening"] && !Shopify.designMode) return;
  try {
    
(()=>{function mount(root){if(root.dataset.ready)return;root.dataset.ready='true';const video=root.querySelector('video'),button=root.querySelector('button'),reduce=matchMedia('(prefers-reduced-motion: reduce)');let paused=reduce.matches;function paint(){root.toggleAttribute('data-paused',paused);button.setAttribute('aria-label',paused?button.dataset.play:button.dataset.pause)}function play(){if(!video.src)video.src=video.dataset.src;video.play().catch(()=>{paused=true;paint()})}button.addEventListener('click',()=>{paused=!paused;paint();if(paused)video.pause();else play()});const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting&&!paused)play();else video.pause()}},{threshold:.15});observer.observe(root);reduce.addEventListener('change',()=>{paused=reduce.matches;paint();if(paused)video.pause();else play()});paint()}document.querySelectorAll('.ahv').forEach(mount);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ahv').forEach(mount))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ala-sensory-guide"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(){document.querySelectorAll('.ad-sensory').forEach(root=>{const rail=root.querySelector('.ad-sensory-notes');if(!rail||rail.dataset.sliderReady)return;rail.dataset.sliderReady='true';const buttons=root.querySelectorAll('[data-sensory-step]');function update(){buttons.forEach(b=>{b.disabled=Number(b.dataset.sensoryStep)<0?rail.scrollLeft<=2:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2})}buttons.forEach(b=>b.addEventListener('click',()=>{const cards=rail.querySelectorAll('.ad-sensory-note');const step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:rail.clientWidth;rail.scrollBy({left:Number(b.dataset.sensoryStep)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}));rail.addEventListener('keydown',e=>{if(e.target!==rail)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();root.querySelector('[data-sensory-step="'+(e.key==='ArrowRight'?'1':'-1')+'"]').click()}});rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update()})}init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ala-short-films"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-afp-section]:not([data-afp-ready])').forEach(section => {
      section.dataset.afpReady = 'true';
      const track = section.querySelector('.afp-track');
      const previous = section.querySelector('[data-afp-prev]');
      const next = section.querySelector('[data-afp-next]');
      const update = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const step = direction => {
        const card = track.querySelector('.afp-card');
        if (!card) return;
        const amount = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left: direction * amount, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(track);
      update();
      const videos = [...section.querySelectorAll('[data-afp-video]')];
      videos.forEach(video => {
        const card = video.closest('.afp-card');
        const button = card.querySelector('[data-afp-play]');
        const error = card.querySelector('.afp-error');
        button.addEventListener('click', () => {
          error.hidden = true;
          if (!video.getAttribute('src')) video.src = video.dataset.videoUrl;
          if (video.error) video.load();
          video.controls = true;
          video.play().catch(() => { button.hidden = false; });
        });
        video.addEventListener('play', () => {
          button.hidden = true;
          videos.forEach(other => { if (other !== video) other.pause(); });
        });
        video.addEventListener('pause', () => { button.hidden = false; });
        video.addEventListener('ended', () => { button.hidden = false; });
        video.addEventListener('error', () => { error.hidden = false; button.hidden = false; });
        new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, {threshold:0}).observe(video);
      });
      document.addEventListener('visibilitychange', () => { if (document.hidden) videos.forEach(video => video.pause()); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ala-visual-compare"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ala-selection-guide'))customElements.define('ala-selection-guide',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const buttons=[...this.querySelectorAll('[data-filter]')],cards=[...this.querySelectorAll('[data-intent]')],status=this.querySelector('.sg-count');this.querySelector('.sg-filters').hidden=false;const select=key=>{let count=0;cards.forEach(card=>{const visible=key==='all'||card.dataset.intent.split(' ').includes(key);card.hidden=!visible;if(visible)count++});buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===key)));status.textContent=count+' '+this.dataset.resultLabel};buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.filter)));select('all')}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
